import { styled } from '@linaria/react';
import { useSpring, animated } from 'react-spring';

import useSequence from './use-sequence.hook';
import Label from './Label';
import {
  BaseWrapper,
  Layer,
  Skew,
  BaseElement,
  BaseMargin,
  InterjectedElement,
  SPRING_CONFIGS,
} from './bits';

function WithBreak() {
  const [stepIndex, step, handlers] = useSequence({
    mode: 'interactive',
  });

  const firstSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : -25}%)`,
    config: SPRING_CONFIGS[0],
  });

  const secondSpring = useSpring({
    transform: `translateX(${stepIndex === 0 ? 0 : 25}%)`,
    config: SPRING_CONFIGS[0],
  });

  return (
    <Wrapper {...handlers}>
      <Layer style={{ zIndex: 3, ...firstSpring }}>
        <Skew>
          <Element>Paragraph One</Element>
          <Margin />
        </Skew>
      </Layer>
      <Layer style={{ zIndex: 2, top: 175 + 32 - 11 }}>
        <Skew>
          <InterjectedElement>{'<br>'}</InterjectedElement>
        </Skew>
      </Layer>

      <Layer style={{ top: 175 + 32, ...secondSpring }}>
        <Skew>
          <Margin />
          <Element>Paragraph Two</Element>
        </Skew>
      </Layer>
    </Wrapper>
  );
}

const Wrapper = styled(BaseWrapper)`
  height: 500px;
`;

const Element = styled(BaseElement)``;
const Margin = styled(BaseMargin)`
  height: 32px;
`;

export default WithBreak;
